class r{constructor(e){this.featureFlags=e}isEnabled(e){return this.featureFlags.includes(e)}raw(){return this.featureFlags}}export{r as FeatureFlags};
//# sourceMappingURL=index.mjs.map
